<template>
  <div class="container" style="padding: 30px; margin-top: 50px">
    <div class="col-md-12 mb-3 mt-3" style="margin: 15px">
        <div class="card generator-card">
          <div class="card-body">

            <div class="inline-form">
              <label class="form-label mb-0">
                จำนวนหมายเลขที่ต้องการสร้าง:
              </label>

              <input v-model.number="number_code_create" type="number" min="1" class="form-control generator-input"
                placeholder="เช่น 5" />

              <button type="button" class="btn btn-success generator-btn" @click="code_create">
                สร้าง
              </button>
            </div>

          </div>
        </div>
      <table class="table table-bordered mt-5">
        <thead>
          <tr class="table">
            <th scope="col" style="text-align:center">ลำดับที่</th>
            <th scope="col" style="text-align:center">หมายเลขสุ่ม</th>
            <th scope="col" style="text-align:center">สถานะการใช้งาน</th>
          </tr>
        </thead>
        <tbody is="draggable" :list="list" tag="tbody">
          <tr style="cursor: move" v-for="(l, i) in list" :key="i">
            <td>
              {{ i + 1 }}
            </td>
            <td>
              {{ l.random_number }}
            </td>
            <td>
              {{ l.active == 0 ? 'ยังไม่ถูกใช้งาน' : 'ถูกใช้งานแล้ว' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import MonitoringNumberService from "../services/MonitoringNumberService";
import draggable from "vuedraggable";

export default {
  name: "Nav",
  components: {
    draggable,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      concert_id: 0,
      list: [],
      user: {},
      user_id: 0,
      hash: 0,
      title: "",
      roles: [],
      code_list: [],
      number_code_create: ''
    };
  },
  mounted() {
    this.getMonitoringNumber();

  },
  methods: {
    code_create() {
      if (this.number_code_create == '') {
        alert('กรุณากรอกจำนวนหมายเลขที่ต้องการสร้าง');
        return;

      }
      this.code_list = [];
      for (let i = 0; i < this.number_code_create; i++) {
        this.code_list.push(Math.floor(1000 + Math.random() * 9000));
      }
      this.create_monitoring_number()
    },
    create_monitoring_number() {
      // console.log(this.code_list);
      for (let c = 0; c < this.code_list.length; c++) {
        let monitoring_number = {
          random_number: this.code_list[c],
          active: 0,
          create_by: this.currentUser.user_id,
          updated_by: this.currentUser.user_id
        }
        MonitoringNumberService.create_monitoring_number(monitoring_number).then(() => {
          // console.log(res.data);
        });

      }
      this.number_code_create = ''
      this.getMonitoringNumber()
    },
    getMonitoringNumber() {
      MonitoringNumberService.getmonitoring_numbers().then((res) => {
        this.list = res.data;
        // console.log(res.data);
      });
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
};
</script>

<style scoped>
.generator-card {
  border: 0;
  border-radius: 14px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, .08);
}

.center-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

/* inline layout */
.inline-form {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.form-label {
  font-weight: 600;
  white-space: nowrap;
}

.generator-input {
  width: 120px;
  border-radius: 10px !important;
  height: 38px;
}

.generator-btn {
  border-radius: 10px;
  padding: 6px 18px;
  font-weight: 600;
}
</style>
